import { reactive } from "@vue/composition-api";


export  const userDetails =  reactive( {
        data:{},
        
      } )